import './FilterContainer.css'
import TeamFilter from '../TeamFilter/TeamFilter'
import DateFilter from '../DateFilter/DateFilter'
import { useFilter } from '../../contexts/FilterContext'
import MatchTeamToggle from '../MatchTeamToggle/MatchTeamToggle'
import { useLocation } from 'react-router-dom'
import PlayerFilter from '../PlayerFilter/PlayerFilter'

const FilterContainer = () => {
  const appliedFilters = useFilter()
  const { pathname } = useLocation()

  return (
    <div className="filterOuterContainer">
      <MatchTeamToggle />
      <div className="filterContainer">
        <TeamFilter selectedTeam={appliedFilters?.selectedTeamId || 0} />
        {pathname === '/match' && (
          <DateFilter selectedDate={appliedFilters?.selectedDate || 0} />
        )}
        {pathname === '/team' && (
          <PlayerFilter
            selectedPlayer={appliedFilters?.selectedPlayerId || 0}
          />
        )}
      </div>
    </div>
  )
}

export default FilterContainer
